"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Color_meta_1 = require("../Color.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', Color_meta_1.COLOR_CATEGORY_KEY, Color_meta_1.COLOR_COMPONENT_KEY, ['wrapper']);